import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useQueryParam(target: string, values: string[], fallback: string): string {
    const [params] = useSearchParams();
    const [val, setVal] = useState(() => {
        const param = params.get(target);
        if (!param) {
            return fallback;
        }
        if (values.includes(param)) {
            return param;
        }
        return fallback;
    });

    useEffect(() => {
        const param = params.get(target);
        if (!param) {
            setVal(fallback);
            return;
        }
        if (values.includes(param)) {
            setVal(param);
            return;
        }
        setVal(fallback);
    }, [fallback, params, target, values]);
    return val;
}
